export enum Message {
   NOT_SERVICEABLE='This product category is not serviceable at your location.',
   PICKUP_NOT_AVAILABLE='Some items in your cart cannot be picked up from this address',
   GEOLOCATION_PERMISSION_DENIED="Location permission denied. Please enter pincode manually or enable location access in your browser settings.",
   GEOLOCATION_POSITION_UNAVAILABLE="Location information is unavailable. Please enter pincode manually.",
   GEOLOCATION_TIMEOUT="Location request timed out. Please try again or enter pincode manually.",
   GEOLOCATION_NOT_SUPPORT="Your browser doesn't support location detection. Please enter pincode manually.",
   GEOLOCATION_ERROR="Unable to detect your location. Please enter pincode manually.",
   PINCODE_INVALID='Pincode is Invalid. Please try again.',
   PINCODE_CITY_ERROR='Error fetching city Please try again.',
   PINCODE_REQUIRED_MSG='6 digits required'


}